import React, { useState, useEffect, useRef } from "react";
import "./Sidebar.css";
import HistorySection from "../history-section/HistorySection";
import IconPlus from "../../common/icons/IconPlus";
import IconChatBot from "../../common/icons/IconChatBot";
import IconSidebar from "../../common/icons/IconSidebar";
import IconCloseSidebar from "../../common/icons/IconCloseSidebar";

const Sidebar = ({
  isOpen,
  toggleSidebar,
  discussions,
  handleSend,
  handleNewDiscussion,
  fetchDiscussions,
  currentConversationId,
  refreshDiscussions, // New prop for triggering refresh
  setRefreshDiscussions, // Allows updating refresh state
  handleDelete,
}) => {
  const [loading, setLoading] = useState(true);
  const version = "1.1.0";
  const discussionsRef = useRef(null); // Reference for scrolling inside discussions

  const discussionScopes = [
    { key: "sameDay", label: "Aujourd'hui" },
    { key: "yesterday", label: "Hier" },
    { key: "recent", label: "Les 7 derniers jours" },
    { key: "last30days", label: "Les 30 derniers jours" },
    { key: "others", label: "Plus anciens" },
  ];

  useEffect(() => {
    setLoading(true);
    fetchDiscussions().then(() => setLoading(false));
  }, [fetchDiscussions]);

  useEffect(() => {
    if (refreshDiscussions) {
      fetchDiscussions();
      setRefreshDiscussions(false);

      // Scroll to top when discussions refresh
      setTimeout(() => {
        if (discussionsRef.current) {
          discussionsRef.current.scrollTo({ top: 0, behavior: "smooth" });
        }
      }, 300); // Ensure state updates before scrolling
    }
  }, [refreshDiscussions, fetchDiscussions, setRefreshDiscussions]);

  return (
    <div className={`sidebar ${isOpen ? "open" : ""}`}>
      {/* Desktop Header */}
      <div className="header desktop-header">
        <div className="logo">
          <IconChatBot />
          <h3>
            Chat AI <span>Beta</span>
          </h3>
        </div>
        <button className="toggle-btn" onClick={toggleSidebar}>
          <IconSidebar />
        </button>
      </div>

      {/* Mobile Header */}
      <div className="header mobile-header">
        <button className="close-sidebar-btn" onClick={toggleSidebar}>
          <IconCloseSidebar />
        </button>
        <h2 className="historique-title">Historique</h2>
        <button className="new-discussion-btn-mobile" onClick={handleNewDiscussion}>
          <IconPlus />
        </button>
      </div>

      <div className="fixed-content">
        <button className="new-discussion-btn desktop-only" onClick={handleNewDiscussion}>
          <IconPlus /> Nouvelle discussion
        </button>
        <div className="discussions desktop-only">
          <h2>Historique :</h2>
        </div>
      </div>

      {/* Scrollable Discussions Container */}
      <div className="discussions-container" ref={discussionsRef}>
        {loading ? (
          <div className="loading-animation"></div>
        ) : (
          <ul>
            {discussionScopes.map(
              (scope) =>
                discussions[scope.key] &&
                discussions[scope.key].length > 0 && (
                  <li key={scope.key}>
                    <HistorySection
                      scope={scope.label}
                      descusion={discussions[scope.key]}
                      handleSend={handleSend}
                      currentConversationId={currentConversationId}
                      handleDelete={handleDelete}
                    />
                  </li>
                )
            )}
          </ul>
        )}
        <p className="version">version {version}</p>
      </div>
    </div>
  );
};

export default Sidebar;
